module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image2-bc440bcd84489053639094e35c006d88.jpg";